import { isly } from "isly";
export var Precision;
(function (Precision) {
    var _a;
    Precision.values = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    _a = isly
        .number("value", ...Precision.values)
        .rename("isoly.Fixed.Precision")
        .bind(), Precision.type = _a.type, Precision.is = _a.is, Precision.flawed = _a.flawed;
})(Precision || (Precision = {}));
//# sourceMappingURL=Precision.js.map